import React from "react";
import imagex from "../../assets/images/carrer/carrer_hero.jpg";
export const Hero = () => {
  return (
    <React.Fragment>
      <div
        className="common-hero-style hero-section position-relative py-5"
        style={{
          backgroundImage: `linear-gradient(to top,rgba(0,0,0,0.7), rgba(0,0,0,0.3)),url(${imagex})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className="black-layer position-absolute top-0 start-0 end-0 bottom-0"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
        ></div>
        <div className="container">
          <div className="row d-flex position-relative justify-content-center align-items-center">
            <div className="col-12 col-lg-8 py-5">
              <div className="hero-text-section position-relative z-index-1">
                <h3 className="text-about text-white">
                  Join Our Team: Ignite Innovation in Automation Engineering
                </h3>
                <h1 className="hero-title text-white">Careers at visves</h1>
                <p className="hero-p text-white">
                  Explore exciting career opportunities at Visves and contribute
                  to shaping the future of automation engineering. Join us to
                  collaborate with industry experts and tackle cutting-edge
                  projects.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
